import Vue from 'vue';
import netbankLogin from './netbank-login/netbank-login.vue';
Vue.component('netbank-login', netbankLogin);
